import { render, staticRenderFns } from "./TqRiddleData.vue?vue&type=template&id=1836d7cc&scoped=true&"
import script from "./TqRiddleData.vue?vue&type=script&lang=js&"
export * from "./TqRiddleData.vue?vue&type=script&lang=js&"
import style0 from "./TqRiddleData.vue?vue&type=style&index=0&id=1836d7cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1836d7cc",
  null
  
)

export default component.exports